import React, { Component, createRef } from "react";
import {
  GET,
  POST,
  loading,
  alert,
  mode,
  setDarkMode,
  params,
} from "../components/CustomComponent.js";
import Turnstile from "react-turnstile";
import LOGO from "../assets/images/logo.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Verify extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settlement_id: "",
      wallet_address: "",
      email: "",
      password: "",
      pin_2fa: "",
      token: "",
      step: 0,
      captchaKey: Date.now(),
    };
    this.turnstileRef = createRef();
  }
  async componentDidMount() {
    try {
      loading(true);
      let data = atob(window.location.pathname.split("/").pop());
      data = data.split(":");
      console.log("PATH:", data);
      if (new Date(Number(data[3])).getTime() < new Date().getTime()) {
        loading(false);
        alert("/", "warning", "Warning", "Invalid URL");
        return;
      } else {
        let result = await GET("callback/settlement/verification", {
          token: data[0],
        });
        if (result?.status === false) {
          loading(false);
          alert("/", "warning", "Warning", "Invalid URL");
          return;
        }
      }
      this.setState({
        settlement_id: data[0],
      });
    } catch (e) {
      console.log("e:", e);
      alert("/", "warning", "Warning", "Invalid URL");
    }
    if (mode === "dark") {
      setDarkMode();
    }
    loading(false);
  }
  async componentDidUpdate() {
    if (mode === "dark") {
      setDarkMode();
    }
  }
  Login = async () => {
    const { token, email, password } = this.state;
    if (!token) {
      alert("", "warning", "Warning", "Please confirm CAPTCHA.");
      return;
    }
    loading(true);
    let result = await POST("v1/public/login", {
      email: email,
      password: btoa(password),
      remember: true,
      token: token,
    });
    if (result?.status) {
      if (result.data.token) {
        this.setState({ step: 1, token: "", captchaKey: Date.now() });
      }
    } else {
      this.setState({ token: "", captchaKey: Date.now() });
      if (
        result.message === "User not verified, please verify your account first"
      ) {
        alert(
          "/resend-verification?email=" + email,
          "warning",
          "Warning",
          "User not verified, please verify your account first",
          "verify",
          "cancel",
        );
      }
    }
    loading(false);
  };
  Verify = async () => {
    const { token, settlement_id, wallet_address, email, password, pin_2fa } =
      this.state;
    if (!token) {
      alert("", "warning", "Warning", "Please confirm CAPTCHA.");
      return;
    }
    if (!wallet_address?.trim()) {
      alert("", "warning", "Warning", "Please input Wallet Address");
      return;
    }
    if (!password?.trim()) {
      alert("", "warning", "Warning", "Please input Password");
      return;
    }
    if (!pin_2fa?.trim()) {
      alert("", "warning", "Warning", "Please input 2FA");
      return;
    }
    loading(true);
    let result = await POST("callback/settlement/verification", {
      token,
      settlement_id,
      wallet_address,
      email,
      password: btoa(password),
      pin_2fa,
    });
    if (result?.status === true) {
      alert(
        "/",
        "success",
        "Success",
        "Your information has been successfully verified. Please wait while our administrators verify your information and processes your request.",
      );
    } else {
      alert(
        "",
        "warning",
        "Warning",
        "Some information is incorrect. Please try again.",
      );
      this.setState({
        token: "",
        captchaKey: Date.now(),
        step: false,
        pin_2fa: "",
        password: "",
      });
    }
    loading(false);
  };

  render() {
    const {
      token,
      settlement_id,
      wallet_address,
      email,
      password,
      pin_2fa,
      captchaKey,
      step,
    } = this.state;

    if (!settlement_id) {
      return null;
    }
    return (
      <div className="w-100 min-vh-100 background position-relative auth-scope">
        <div className="row w-100 mx-0">
          <div
            className={`col-12 d-flex align-items-center justify-content-center d-md-none auth-brand py-3`}
          >
            <img
              alt="logo"
              src={LOGO}
              className="w-75"
              style={{ minWidth: 350 }}
            />
          </div>
          <div
            className={`col-6 d-none d-md-flex align-items-center justify-content-center auth-brand min-vh-100`}
          >
            <img
              alt="logo"
              src={LOGO}
              style={{ width: "60%", minWidth: 400 }}
            />
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
            <div className="col-11 col-md-10 col-lg-7 col-xl-6 mx-auto my-5 auth-card">
              <h3 className="fw-bold text-dark mb-3">
                Settlement Verification
              </h3>
              <div className="mb-3">
                <small>
                  Used to verify wallet information and validate bank account
                  details before processing transactions.
                </small>
              </div>
              {step === 0 ? (
                <div>
                  <label className="mb-1">Email</label>
                  <input
                    className="form-control mb-3"
                    type="text"
                    placeholder="Email"
                    onChange={(e) => {
                      this.setState({ email: e.target.value });
                    }}
                    value={email}
                  />
                  <label className="mb-1">Password</label>
                  <input
                    className="form-control mb-3"
                    type="password"
                    placeholder="Password"
                    onChange={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                    value={password}
                  />
                </div>
              ) : step === 1 ? (
                <div>
                  <label className="mb-1">Wallet Address</label>
                  <input
                    className="form-control mb-3"
                    type="text"
                    placeholder="Wallet Address"
                    onChange={(e) => {
                      this.setState({ wallet_address: e.target.value });
                    }}
                    value={wallet_address}
                  />
                </div>
              ) : (
                <div>
                  <label className="mb-1">Two-Factor Authentication</label>
                  {/* <input
                className="form-control mb-3"
                type="text"
                placeholder="2FA"
                onChange={(e) => {
                  this.setState({ pin_2fa: e.target.value });
                }}
                value={pin_2fa}
              /> */}
                  <div className="d-flex justify-content-start mb-5">
                    {Array.from({ length: 6 }).map((_, index) => (
                      <input
                        key={index}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="1"
                        className="form-control text-center mx-1"
                        style={{ width: "3rem", fontSize: "1.5rem" }}
                        value={pin_2fa[index] || ""}
                        onChange={(e) => {
                          let val = e.target.value.replace(/[^0-9]/g, "");
                          let newPin2fa = pin_2fa.split("");
                          newPin2fa[index] = val;
                          const updatedPin2fa = newPin2fa.join("");
                          this.setState({ pin_2fa: updatedPin2fa }, () => {
                            if (val && index < 5) {
                              document
                                .getElementById(`otp-${index + 1}`)
                                .focus();
                            }
                          });
                        }}
                        onKeyDown={(e) => {
                          if (
                            e.key === "Backspace" &&
                            !pin_2fa[index] &&
                            index > 0
                          ) {
                            document.getElementById(`otp-${index - 1}`).focus();
                          }
                        }}
                        onPaste={(e) => {
                          e.preventDefault();
                          const paste = e.clipboardData
                            .getData("text")
                            .replace(/[^0-9]/g, "");
                          if (paste.length !== 6) {
                            let newPin2fa = pin_2fa.split("");
                            paste.split("").forEach((char, i) => {
                              if (index + i < 6) {
                                newPin2fa[index + i] = char;
                              }
                            });
                            this.setState(
                              { pin_2fa: newPin2fa.join("") },
                              () => {
                                const nextIndex = Math.min(
                                  index + paste.length,
                                  5,
                                );
                                document
                                  .getElementById(`otp-${nextIndex}`)
                                  .focus();
                              },
                            );
                          }
                        }}
                        id={`otp-${index}`}
                      />
                    ))}
                  </div>
                </div>
              )}
              <div className="w-100 mb-2">
                <Turnstile
                  key={captchaKey}
                  size="flexible"
                  sitekey={process.env.REACT_APP_CLOUDFLARE_SITE_KEY}
                  onVerify={(token) => {
                    this.setState({ token });
                  }}
                  onExpire={() => {
                    this.setState({ token: "" });
                  }}
                />
              </div>
              <button
                type="button"
                className={`btn ${
                  token ? "btn-dark" : "btn-secondary"
                } w-100 mb-3`}
                onClick={() => {
                  if (step === 0) {
                    if (!password?.trim()) {
                      alert("", "warning", "Warning", "Please input Password");
                      return;
                    }
                    if (!email?.trim()) {
                      alert("", "warning", "Warning", "Please input Email");
                      return;
                    }
                    this.Login();
                  } else if (step === 1) {
                    if (!wallet_address?.trim()) {
                      alert(
                        "",
                        "warning",
                        "Warning",
                        "Please input Wallet Address",
                      );
                      return;
                    }

                    this.setState({ step: 2 });
                  } else {
                    this.Verify();
                  }
                }}
                disabled={!token}
              >
                {!step ? "Next" : "Verify"}
              </button>
              <div className="w-100 text-center">
                <small className="text-secondary text-center">
                  Copyright © 2025 SwiftGoldPay version {global.version}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
